import React from "react";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "./Title";

function preventDefault(event) {
    event.preventDefault();
}

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
});

export default function Deposits({ title, value, date }) {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Title>{title}</Title>
            <Typography component="p" variant="h4">
                {value}
            </Typography>
            <Typography
                color="textSecondary"
                className={classes.depositContext}
            >
                {date || "13 Feb, 2021"}
            </Typography>
            <div>
                <Link color="primary" href="#" onClick={preventDefault}>
                    reedeem tokens
                </Link>
            </div>
        </React.Fragment>
    );
}
